var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlasticProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#FEF0ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15.75H22.5C22.6989 15.75 22.8897 15.671 23.0303 15.5303C23.171 15.3897 23.25 15.1989 23.25 15V14.25C23.25 14.0511 23.171 13.8603 23.0303 13.7197C22.8897 13.579 22.6989 13.5 22.5 13.5H19.5C19.3011 13.5 19.1103 13.579 18.9697 13.7197C18.829 13.8603 18.75 14.0511 18.75 14.25V15C18.75 15.1989 18.829 15.3897 18.9697 15.5303C19.1103 15.671 19.3011 15.75 19.5 15.75ZM24.75 21.75C24.75 21.3522 24.592 20.9706 24.3107 20.6893C24.0294 20.408 23.6478 20.25 23.25 20.25C23.6478 20.25 24.0294 20.092 24.3107 19.8107C24.592 19.5294 24.75 19.1478 24.75 18.75C24.75 18.3522 24.592 17.9706 24.3107 17.6893C24.0294 17.408 23.6478 17.25 23.25 17.25H18.75C18.3522 17.25 17.9706 17.408 17.6893 17.6893C17.408 17.9706 17.25 18.3522 17.25 18.75C17.25 19.1478 17.408 19.5294 17.6893 19.8107C17.9706 20.092 18.3522 20.25 18.75 20.25C18.3522 20.25 17.9706 20.408 17.6893 20.6893C17.408 20.9706 17.25 21.3522 17.25 21.75C17.25 22.1478 17.408 22.5294 17.6893 22.8107C17.9706 23.092 18.3522 23.25 18.75 23.25C18.3522 23.25 17.9706 23.408 17.6893 23.6893C17.408 23.9706 17.25 24.3522 17.25 24.75V27C17.25 27.3978 17.408 27.7794 17.6893 28.0607C17.9706 28.342 18.3522 28.5 18.75 28.5H23.25C23.6478 28.5 24.0294 28.342 24.3107 28.0607C24.592 27.7794 24.75 27.3978 24.75 27V24.75C24.75 24.3522 24.592 23.9706 24.3107 23.6893C24.0294 23.408 23.6478 23.25 23.25 23.25C23.6478 23.25 24.0294 23.092 24.3107 22.8107C24.592 22.5294 24.75 22.1478 24.75 21.75Z",
    fill: "#BC030E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasticProducts);
export default __webpack_public_path__ + "static/media/plastic_products.d67584dec4bba7c18c9299c80e764211.svg";
export { ForwardRef as ReactComponent };